// icons
import DoneIcon from '@assets/icons/done.svg';
import FailIcon from '@assets/icons/fail.svg';

import { UserTariff, Tariff } from '@libs/types';

// styles
import css from './styles.module.css';

interface IProps {
  tariffInfo: {
    user_tariff: UserTariff;
    tariff_name: string;
    trial_days: number | null;
    sub_active_flag: number;
    tariff: Tariff;
  };
}

function TariffPlans({ tariffInfo }: IProps) {
  const { trial_days, sub_active_flag, tariff, tariff_name } = tariffInfo;

  if (trial_days && sub_active_flag === 1) {
    return (
      <div className={css.root}>
        <h5 className={css.title}>
          {trial_days} days free trial left
          <img
            className={css.doneIcon}
            src={DoneIcon}
            alt=""
            width="24"
            height="24"
          />
        </h5>

        <span className={css.description}>
          Choose a plan for your business needs
        </span>
      </div>
    );
  }

  if (trial_days && sub_active_flag == 0) {
    return (
      <div className={css.root}>
        <h5 className={css.title}>
          Trial over
          <img
            className={css.icon}
            src={FailIcon}
            alt=""
            width="24"
            height="24"
          />
        </h5>

        <span className={css.description}>Upgrade your plan</span>
      </div>
    );
  }

  if (sub_active_flag == 1 && tariffInfo.tariff_name) {
    return (
      <div className={css.root}>
        <h5 className={css.title}>
          {tariff_name} Plan
          <img
            className={css.icon}
            src={DoneIcon}
            alt=""
            width="24"
            height="24"
          />
        </h5>

        <span className={css.description}>
          {tariff.duration_in_months === 12
            ? 'Renews yearly'
            : 'Renews monthly'}
        </span>
      </div>
    );
  }

  if (sub_active_flag === 0 && tariff_name) {
    return (
      <div className={css.root}>
        <h5 className={css.title}>
          {tariff_name} Plan
          <img
            className={css.icon}
            src={FailIcon}
            alt=""
            width="24"
            height="24"
          />
        </h5>

        <span className={css.description}>Access to TurboPush is limited</span>
      </div>
    );
  }

  return null;
}

export default TariffPlans;
